document.addEventListener('DOMContentLoaded', () => {
    const flashMessages = document.querySelectorAll('[data-dismiss="flash"]');
    flashMessages.forEach((flash) => {
        setTimeout(() => {
            flash.style.display = 'none';
        }, 5000);
    });
});